<template>
  <div>
    <v-row
      class=""
    >
      <v-col cols="4" class="py-1">
        <v-section-panel>
          <template v-slot:title> 品詞の限定（※複数選択可）</template>
          <template v-slot:content>
            <v-choice-question-checkboxes checkboxList="hinshi" />
          </template>
        </v-section-panel>
      </v-col>

    </v-row>

    <!-- 区切り線 -->
    <div v-if="useBreak">
      <p class="v-section-panel__break-line"/>
    </div>

  </div>
</template>

<script>
import VSectionPanel from '@/components/molecules/SectionPanel'
import VChoiceQuestionCheckboxes from '@/components/molecules/ChoiceQuestionCheckboxes'
export default {
  components: {
    VSectionPanel,
    VChoiceQuestionCheckboxes,
  },

  data: () => ({
    checkboxList: "",
  }),

  props: {
    useBreak: {
      type: Boolean,
      default: false,
    }
  },

  computed: {
  },

  methods: {
  },
}
</script>

<style lang="stylus" scoped>
.v-section-panel
  &__title
    color rgb(120 112 112 / 1)
    font-weight bold
    margin-bottom 10px

  &__break-line
    margin-top 26px
    margin-bottom 32px
    border-bottom 1px dashed gray
</style>>
